// src/components/Sidebar.tsx

import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  LayoutDashboard,
  FolderOpen,
  BarChart2,
  Settings,
  Upload,
  BookOpen,
  Users,
  Network,
  ChevronLeft,
  ChevronRight,
  ShipWheelIcon,
  // MessageSquarePlus
} from 'lucide-react';

const navItems = [
  { icon: LayoutDashboard, label: 'Dashboard', path: '/dashboard' },
  { icon: FolderOpen, label: 'Documents', path: '/documents' },
  { icon: Users, label: 'Organizations', path: '/organizations' },
  { icon: Network, label: 'Knowledge Graph', path: '/graph' },
  { icon: Upload, label: 'Upload', path: '/upload' },
  { icon: ShipWheelIcon, label: 'Configurations', path: '/config' },
  // { icon: MessageSquarePlus, label: 'New Chat', path: '#' },
];

interface SidebarProps {
  isCollapsed: boolean;
  toggleCollapse: () => void;
}

export const Sidebar: React.FC<SidebarProps> = ({ isCollapsed, toggleCollapse }) => {
  const location = useLocation();

  return (
    <div
      className={`flex flex-col bg-white border-r border-gray-200 ${
        isCollapsed ? 'w-16' : 'w-64'
      } transition-all duration-300`}
    >
      {/* Logo and Toggle */}
      <div className="h-16 flex items-center justify-between px-4 border-b border-gray-200">
        <div className="flex items-center">
          
          {!isCollapsed && (
            <>
              <BookOpen className="h-8 w-8 text-blue-600" />
              <span className="ml-2 text-lg font-semibold text-gray-900">Antz</span>
            </>
          )}
        </div>
        <button
          onClick={toggleCollapse}
          className="p-2 text-gray-600 hover:text-gray-900"
        >
          {isCollapsed ? <ChevronRight className="h-5 w-5" /> : <ChevronLeft className="h-5 w-5" />}
        </button>
      </div>

      {/* Navigation */}
      <nav className="flex-1 px-4 py-4">
        <div className="space-y-1">
          {navItems.map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center ${
                  isCollapsed ? 'justify-center' : 'px-3'
                } py-2 rounded-lg text-sm font-medium ${
                  isActive
                    ? 'bg-blue-50 text-blue-700'
                    : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                }`}
              >
                <item.icon
                  className={`h-6 w-6 ${
                    isActive ? 'text-blue-700' : 'text-gray-400'
                  }`}
                />
                {!isCollapsed && <span className="ml-3">{item.label}</span>}
              </Link>
            );
          })}
        </div>
      </nav>

      {/* Settings */}
      <div className="p-4 border-t border-gray-200">
        <Link
          to="/settings"
          className={`flex items-center ${
            isCollapsed ? 'justify-center' : 'px-3'
          } py-2 rounded-lg text-sm font-medium text-gray-600 hover:bg-gray-50 hover:text-gray-900`}
        >
          <Settings
            className="h-6 w-6 text-gray-400"
          />
          {!isCollapsed && <span className="ml-3">Settings</span>}
        </Link>
      </div>
    </div>
  );
};
